/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type SetKeyEnabledRequestBody = {
  /**
   * Whether the key participates in key resolution.
   */
  enabled: boolean;
  /**
   * The ID of the key to update.
   */
  id: string;
};

/** @internal */
export type SetKeyEnabledRequestBody$Outbound = {
  enabled: boolean;
  id: string;
};

/** @internal */
export const SetKeyEnabledRequestBody$outboundSchema: z.ZodMiniType<
  SetKeyEnabledRequestBody$Outbound,
  SetKeyEnabledRequestBody
> = z.object({
  enabled: z.boolean(),
  id: z.string(),
});

export function setKeyEnabledRequestBodyToJSON(
  setKeyEnabledRequestBody: SetKeyEnabledRequestBody,
): string {
  return JSON.stringify(
    SetKeyEnabledRequestBody$outboundSchema.parse(setKeyEnabledRequestBody),
  );
}
